import { qc } from '@/lib/queryClient'
import { useOrg } from '@/stores/org'
import { ACTIVE_ORG_KEY } from '@/lib/constants'
import { TENANT_KEY_PREFIXES } from '@/lib/storageKeys'

/**
 * Tenant teardown — wipes every piece of org/session-bound client state:
 * TanStack cache (queries + mutations), the org store + persisted active org,
 * stored gateway keys (sessionStorage + localStorage copies), and
 * multipart upload resume entries. Called on logout, on definitive session
 * loss (refresh → 401), and after a successful login/register so an account
 * switch can't inherit the previous tenant's residue. Does NOT touch
 * useAuth.user — callers own that transition.
 */
export function teardownSession(): void {
  qc.clear()
  useOrg.setState({ orgs: [], activeOrgId: null, loading: true, error: null })
  try {
    localStorage.removeItem(ACTIVE_ORG_KEY)
    for (const store of [sessionStorage, localStorage]) {
      for (const k of Object.keys(store)) {
        // TENANT_KEY_PREFIXES — 'togence:api-key:*' = per-org gateway keys,
        // 'togence:mpu:*' = multipart resume entries (registry: storageKeys.ts).
        if (TENANT_KEY_PREFIXES.some((p) => k.startsWith(p))) {
          store.removeItem(k)
        }
      }
    }
  } catch {
    // storage unavailable — in-memory stores already cleared above
  }
}
